import SongDetailView from './SongDetailView'

export default SongDetailView
